import React from 'react';
import { IS_EUROPE, localePath } from '../../config/region';

/*
 * A paragraph whose whole point is to send the reader to /authors.
 *
 * That page is routed in russia only (see App.js): the intake behind it is a Russian-language
 * application handled over Telegram, and Plotex does not run it. So on europe the paragraph is
 * dropped rather than rendered with a dead link — including on plotex.io/ru, which serves the
 * Russian text of these posts from the European build.
 *
 * Children are the sentence in whatever language the post is being read in; wrap the page name
 * in <AuthorsApply.Link> so one component covers all seven.
 */
export const AuthorsApply = ({ children }) =>
  IS_EUROPE ? null : <p>{children}</p>;

AuthorsApply.Link = ({ children }) => <a href={localePath('/authors')}>{children}</a>;

export default AuthorsApply;
